// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationPlaceholderPath = 'M50 100c27.614 0 50-22.386 50-50S77.614 0 50 0 0 22.386 0 50s22.386 50 50 50zm0-7a42.83 42.83 0 0027.83-10.22L50 54.95 22.17 82.78A42.83 42.83 0 0050 93zM17.22 77.83L45.05 50 17.22 22.17A42.829 42.829 0 007 50a42.829 42.829 0 0010.22 27.83zM50 45.05L22.17 17.22A42.829 42.829 0 0150 7a42.829 42.829 0 0127.83 10.22L50 45.05zM54.95 50l27.83-27.83A42.83 42.83 0 0193 50a42.83 42.83 0 01-10.22 27.83L54.95 50z';
var IllustrationPlaceholder = baseIllustration('IllustrationPlaceholder', {
  getPath: () => IllustrationPlaceholderPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationPlaceholder;
//# sourceMappingURL=index.js.map